export type RelatedArticle = {
  id: string
  category: string
  title: string
  image: string
  imageAlt: string
}

export const relatedNews: RelatedArticle[] = [
  {
    id: 'sueno',
    category: 'Descanso',
    title:
      'El hábito nocturno de 2 minutos que mejora la calidad del sueño profundo en mujeres estresadas.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8ba3eaa6-959c-400d-8260-9e16dd90cf55.jpg',
    imageAlt: 'Mujer durmiendo plácidamente en su cama',
  },
  {
    id: 'limon',
    category: 'Mitos',
    title:
      '¿Es el agua con limón realmente un detox? La verdad científica detrás del mito matutino.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ae06688e-ba28-4967-a8d6-3504ddab0c47.jpg',
    imageAlt: 'Vaso de agua con limón y hojas de menta',
  },
  {
    id: 'caminar',
    category: 'Movimiento',
    title:
      'Caminar vs. Correr: ¿Cuál es la mejor opción para proteger tus articulaciones después de los 40?',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dec80d68-f3df-4b72-94ce-b90dfb6542a7.jpg',
    imageAlt: 'Tenis de correr en la puerta de una casa',
  },
]
